import React from "react";
import Icon from "react-icons-kit";
import Menubar from "./../components/menubar";
import Logo from "./../components/logo";
import Shot from "./../components/home";
import Projects from "./../components/projects";
import Checklist from "./../components/checklist";
import Notes from "./../components/notes";
import { windows, linux, apple } from "react-icons-kit/fa";
export default () => (
  <main className="wrapper">
    <section className="hero">
      <div className="grid-bg" />
      <div className="info">
        <div>
          <Logo style={{ margin: "20px" }} />
          <h1 className="title">
            Get your day <br />
            organized with snipnote
          </h1>
          <p className="text">
            Organize your day with notes and checklist and mark them complete
            when you are done..
          </p>
          <div className="download ">
            <a href="https://gum.co/TlNUJ">
              <Icon icon={windows} />
            </a>
            <a href="https://gum.co/XJajl">
              <Icon icon={linux} />
            </a>
            {/* <a href="https://gum.co/bvsTb">
              <Icon icon={apple} />
            </a> */}
          </div>
          <a
            href="https://www.producthunt.com/posts/snipnote?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-snipnote"
            target="_blank"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=187318&theme=light"
              alt="snipnote - Orgainize your day with tasks with notes and checklist | Product Hunt Embed"
              style={{
                width: "250px",
                height: "54px"
              }}
            />
          </a>
        </div>
      </div>
      <div className="showcase">
        <div className="menubar">
          <Menubar />
        </div>
        <Shot />
      </div>
    </section>
    <section>
      <div className="grid-wrapper">
        <div className="feature">
          <h3 class="title">Projects</h3>
          <span class="text">
            Manage your notes and task into Projects / Routines.
          </span>
          <div className="illustration">
            <Projects style={{ maxWidth: "320px" }} />
          </div>
        </div>
        <div className="feature">
          <h3 class="title">Tasks</h3>
          <span class="text">
            Add tasks to projects / Routines. When completed mark as Read ✔
          </span>
          <div className="illustration">
            <Shot style={{ maxWidth: "320px" }} />
          </div>
        </div>
        <div className="feature">
          <h3 class="title">Notes</h3>
          <span class="text">
            Give meaningful notes to know more about the Task.
          </span>
          <div className="illustration">
            <Notes style={{ maxWidth: "320px" }} />
          </div>
        </div>
        <div className="feature">
          <h3 class="title">Checklist</h3>
          <span class="text">
            Maintain checklist to manage todos within Tasks.
          </span>
          <div className="illustration">
            <Checklist style={{ maxWidth: "320px" }} />
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <span style={{ flex: 1 }} />
      <div class="footer right">
        <div class="footer social">
          {/* <!-- <div class="footer social-item"><a href="https://github.com/achuthhadnoor/" class="footer"><svg
                            width="12px" viewBox="0 0 16 16">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                transform="translate(-152.000000, -534.000000)">
                                <g transform="translate(121.000000, 534.000000)" fill="#000000" fill-rule="nonzero">
                                    <g transform="translate(31.000000, 0.000000)">
                                        <path
                                            d="M8.00006625,0 C3.58233079,0 0,3.66762843 0,8.19206784 C0,11.811538 2.29226248,14.8822747 5.47093356,15.9654975 C5.87075139,16.0413299 6.01753675,15.7877866 6.01753675,15.5714133 C6.01753675,15.3760669 6.01011799,14.7307455 6.00667356,14.0462193 C3.78104741,14.541775 3.31141379,13.0796616 3.31141379,13.0796616 C2.9474974,12.1327743 2.4231505,11.8809944 2.4231505,11.8809944 C1.69730491,11.3725512 2.47786379,11.3829968 2.47786379,11.3829968 C3.28120887,11.4407868 3.70421031,12.2271917 3.70421031,12.2271917 C4.41773547,13.4795791 5.57572346,13.11751 6.03224178,12.9081908 C6.10404472,12.3787208 6.31137244,12.0173299 6.54016144,11.8127588 C4.76323744,11.6056102 2.89530119,10.9031772 2.89530119,7.76420493 C2.89530119,6.8698169 3.20781618,6.13903156 3.71957773,5.5653372 C3.63651417,5.35900257 3.36268268,4.52579597 3.79707721,3.39739927 C3.79707721,3.39739927 4.46887188,3.1772276 5.99766507,4.23711741 C6.63581044,4.05560806 7.32019044,3.96458207 8.00006625,3.96146196 C8.67994206,3.96458207 9.364852,4.05560806 10.0041896,4.23711741 C11.5311281,3.1772276 12.2019954,3.39739927 12.2019954,3.39739927 C12.6374498,4.52579597 12.3634858,5.35900257 12.2804223,5.5653372 C12.7933761,6.13903156 13.1037714,6.8698169 13.1037714,7.76420493 C13.1037714,10.9106384 11.2322583,11.6034398 9.45083006,11.8062473 C9.73777687,12.060469 9.99345887,12.5590092 9.99345887,13.323302 C9.99345887,14.4194123 9.9841855,15.3015911 9.9841855,15.5714133 C9.9841855,15.7894145 10.1281887,16.044857 10.5337031,15.9644122 C13.710652,14.8799684 16,11.8103171 16,8.19206784 C16,3.66762843 12.4181992,0 8.00006625,0 Z M2.99628496,11.6697736 C2.97866541,11.7104707 2.91613591,11.7226799 2.85917048,11.6947345 C2.80114522,11.66801 2.76855571,11.6125262 2.78736755,11.5716934 C2.80458965,11.5297753 2.86725163,11.5181088 2.92514439,11.5461898 C2.98330214,11.5729143 3.01642157,11.6289407 2.99628496,11.6697736 Z M3.38979933,12.0293283 C3.35164574,12.0655487 3.27706077,12.0487272 3.22645426,11.9914799 C3.17412555,11.9343683 3.16432221,11.8579932 3.2030057,11.8212301 C3.24235159,11.7850096 3.31468445,11.8019668 3.36714564,11.8590785 C3.41947433,11.9168684 3.42967512,11.9927008 3.38979933,12.0293283 Z M3.65976508,12.4893662 C3.61074833,12.5242301 3.53059929,12.4915367 3.48105261,12.4186888 C3.43203583,12.3458409 3.43203583,12.2584776 3.48211244,12.2234781 C3.53179157,12.1884785 3.61074833,12.219951 3.66095738,12.2922563 C3.70984168,12.3663251 3.70984168,12.4536883 3.65976508,12.4893662 Z M4.11633495,13.0221551 C4.07248482,13.0716701 3.97908802,13.0583757 3.91072948,12.9908184 C3.84078124,12.9247533 3.82130701,12.8310141 3.86528963,12.7814993 C3.90966966,12.7318488 4.00359639,12.7458214 4.07248482,12.8128361 C4.14190316,12.8787656 4.1630996,12.973183 4.11633495,13.0221551 Z M4.70640719,13.2020187 C4.68706546,13.2661846 4.59711306,13.2953508 4.50649828,13.2680838 C4.41601597,13.2400028 4.35679843,13.1648487 4.37508036,13.1000045 C4.39389219,13.0354317 4.48424201,13.0050445 4.57551918,13.0342108 C4.66586901,13.0621562 4.72521905,13.1367676 4.70640719,13.2020187 Z M5.37793419,13.2783121 C5.38018629,13.3458694 5.30334919,13.4018958 5.20823018,13.4031168 C5.11258125,13.4052873 5.03521425,13.3506175 5.03415442,13.2841454 C5.03415442,13.2159098 5.1092693,13.160426 5.20491823,13.1587981 C5.30003726,13.1568989 5.37793419,13.2111618 5.37793419,13.2783121 Z M6.03763419,13.2524175 C6.04902729,13.3183469 5.98292088,13.3860398 5.88846425,13.4040822 C5.79559736,13.4214463 5.70961929,13.3807492 5.69782877,13.3153624 C5.68630322,13.2478051 5.75360191,13.1801122 5.84633633,13.1626125 C5.94092544,13.145791 6.02557872,13.1854028 6.03763419,13.2524175 Z">
                                        </path>
                                    </g>
                                </g>
                            </g>
                        </svg></a></div> --> */}
          <div class="footer social-item">
            <a href="https://twitter.com/achuth_hadnoor" class="footer">
              <svg width="12px" viewBox="0 0 16 13">
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(-121.000000, -535.000000)"
                >
                  <g
                    transform="translate(121.000000, 534.000000)"
                    fill="#000000"
                    fill-rule="nonzero"
                  >
                    <g transform="translate(0.000000, 1.000000)">
                      <path d="M16,1.58301597 C15.4113026,1.84284437 14.7786532,2.01845133 14.1146348,2.09743078 C14.7924064,1.69309794 15.3128644,1.05287516 15.5579648,0.290047842 C14.9237353,0.664384799 14.2212078,0.936269803 13.4734994,1.08281279 C12.8746772,0.44789025 12.0215662,0.0511291866 11.0774498,0.0511291866 C9.26453781,0.0511291866 7.79475475,1.51382158 7.79475475,3.31794283 C7.79475475,3.57398535 7.82384137,3.82332976 7.87979075,4.06242314 C5.15161491,3.92618942 2.73285782,2.62559128 1.11383737,0.649124758 C0.831281319,1.13162162 0.669402687,1.69280672 0.669402687,2.29150122 C0.669402687,3.42487961 1.24897034,4.42482 2.12976334,5.01064248 C1.59163101,4.99369335 1.08551154,4.84674265 0.642891106,4.6020578 C0.642657012,4.615687 0.642657012,4.62937444 0.642657012,4.64312012 C0.642657012,6.22597076 1.77416877,7.54637205 3.27584769,7.84644732 C3.00037309,7.92111671 2.71038443,7.96101414 2.41097334,7.96101414 C2.19946596,7.96101414 1.99381104,7.94057031 1.79342331,7.90242022 C2.21111233,9.20033916 3.42338783,10.1448308 4.85981199,10.1712156 C3.73637661,11.0473865 2.32096272,11.5696644 0.783057169,11.5696644 C0.518116976,11.5696644 0.256805296,11.5542296 0,11.5240589 C1.45269396,12.4509608 3.17817038,12.9917604 5.03193241,12.9917604 C11.0697831,12.9917604 14.3714986,8.01378357 14.3714986,3.69676461 C14.3714986,3.55511416 14.3683383,3.41422088 14.3620176,3.27414302 C15.0033286,2.81354606 15.5598961,2.23814932 16,1.58301597" />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </div>
          <div class="footer social-item">
            <a href="https://uiuxdx.now.sh">
              <h5>UIUXDX</h5>
            </a>
            <a href="mailto:achuth.hadnoor123@gmail.com" class="footer">
              achuth.hadnoor123@gmail.com
            </a>
          </div>
        </div>
        <p class="footer">Copyright © 2020 Snipnote. All rights reserved.</p>
      </div>
    </footer>
  </main>
);
